module.exports = __webpack_public_path__ + "img/68502aa.webp";